(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-podcast-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let activeRoot = null;
    let activeAudio = null;
    let activeButton = null;

    const findAudio = (root, audioId) => {
      if (!audioId) return null;
      try {
        return root.querySelector(`#${CSS.escape(audioId)}`);
      } catch {
        return root.querySelector(`#${audioId}`);
      }
    };

    const findPlayButton = (root, audio) => {
      if (!audio?.id) return null;
      try {
        return root.querySelector(`[data-audio-id="${CSS.escape(audio.id)}"]`);
      } catch {
        return root.querySelector(`[data-audio-id="${audio.id}"]`);
      }
    };

    const ensureAudioSrc = (audio) => {
      if (!(audio instanceof HTMLAudioElement)) return false;

      if (audio.src && audio.src !== window.location.href) return true;

      const dataSrc = audio.dataset.src?.trim();
      if (dataSrc) {
        audio.src = dataSrc;
        audio.load();
        return true;
      }

      return audio.querySelector('source[src]') != null;
    };

    const setPlayingState = (button, isPlaying, hasError = false) => {
      if (!(button instanceof HTMLButtonElement)) return;
      button.classList.toggle('is-playing', isPlaying);
      button.classList.toggle('is-error', hasError);
      button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      const idle = button.dataset.labelIdle || 'OUVIR AGORA';
      const playing = button.dataset.labelPlaying || 'Pausar áudio';
      button.setAttribute('aria-label', hasError ? idle : isPlaying ? playing : idle);
    };

    const stopActive = () => {
      if (activeAudio) {
        activeAudio.pause();
        if (activeButton) setPlayingState(activeButton, false);
      }
      activeRoot = null;
      activeAudio = null;
      activeButton = null;
    };

    const pauseOthersInRoot = (root, currentAudio) => {
      root.querySelectorAll('audio').forEach((other) => {
        if (other === currentAudio || !(other instanceof HTMLAudioElement)) return;
        if (!other.paused) {
          other.pause();
          const otherBtn = findPlayButton(root, other);
          if (otherBtn) setPlayingState(otherBtn, false);
        }
      });
    };

    const playAudio = async (root, button, audio) => {
      if (!ensureAudioSrc(audio)) {
        setPlayingState(button, false, true);
        return;
      }

      pauseOthersInRoot(root, audio);
      stopActive();
      activeRoot = root;
      activeAudio = audio;
      activeButton = button;

      try {
        await audio.play();
        setPlayingState(button, true);
      } catch {
        setPlayingState(button, false, true);
        activeRoot = null;
        activeAudio = null;
        activeButton = null;
      }
    };

    const onPlayClick = (event) => {
      const button = event.target.closest('[data-podcast-play]');
      if (!(button instanceof HTMLButtonElement)) return;

      const root = button.closest('[data-editorial-podcast-root]');
      if (!root) return;

      event.preventDefault();

      const audio = findAudio(root, button.getAttribute('data-audio-id'));
      if (!(audio instanceof HTMLAudioElement)) {
        setPlayingState(button, false, true);
        return;
      }

      if (activeAudio === audio && !audio.paused) {
        audio.pause();
        setPlayingState(button, false);
        stopActive();
        return;
      }

      playAudio(root, button, audio);
    };

    const onAudioEnded = (event) => {
      const audio = event.target;
      if (!(audio instanceof HTMLAudioElement)) return;
      const root = audio.closest('[data-editorial-podcast-root]');
      if (!root) return;
      const button = findPlayButton(root, audio);
      if (button) setPlayingState(button, false);
      if (activeAudio === audio) stopActive();
    };

    const bindRoot = (root) => {
      if (!(root instanceof HTMLElement) || root.dataset.podcastAudioBound === 'true') return;
      root.dataset.podcastAudioBound = 'true';
      root.addEventListener('click', onPlayClick);
      root.addEventListener('ended', onAudioEnded, true);
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-editorial-podcast-root]').forEach(bindRoot);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target) init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-product-hero"] && !Shopify.designMode) return;
  try {
    
  class EditorialProductBuyNow extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
    }

    #onClick = async (event) => {
      event.preventDefault();
      if (this.disabled) return;

      const formComponent = this.closest('product-form-component');
      const form = formComponent?.querySelector('form');
      if (!form || !window.fetch) return;

      const formData = new FormData(form);
      const variantId = formData.get('id');
      if (!variantId) return;

      this.disabled = true;

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.description || data?.message || 'Cart error');
        }

        const checkoutUrl = `${window.Shopify?.routes?.root || '/'}checkout`;
        window.location.href = checkoutUrl;
      } catch (error) {
        console.error(error);
        this.disabled = false;
      }
    };
  }

  if (!customElements.get('editorial-product-buy-now')) {
    customElements.define('editorial-product-buy-now', EditorialProductBuyNow);
  }

  class EditorialProductDescription extends HTMLElement {
    #desc;
    #btn;
    #media;
    #onMediaChange = () => this.#updateClamp();

    connectedCallback() {
      if (this.hasAttribute('data-clamp-disabled')) return;

      this.#desc = this.querySelector('.editorial-product-hero__description--clampable');
      this.#btn = this.querySelector('.editorial-product-hero__description-toggle');
      if (!this.#desc || !this.#btn) return;

      this.#btn.addEventListener('click', this.#onExpand);
      this.#media = window.matchMedia('(min-width: 750px)');
      this.#media.addEventListener('change', this.#onMediaChange);
      this.#updateClamp();
    }

    disconnectedCallback() {
      this.#btn?.removeEventListener('click', this.#onExpand);
      this.#media?.removeEventListener('change', this.#onMediaChange);
    }

    #onExpand = () => {
      this.#desc.classList.remove('is-clamped');
      this.#desc.classList.add('is-expanded');
      this.#btn.hidden = true;
    };

    #updateClamp() {
      if (!this.#media?.matches) {
        this.#btn.hidden = true;
        this.#desc.classList.remove('is-clamped', 'is-expanded');
        return;
      }

      this.#desc.classList.remove('is-expanded');
      this.#desc.classList.add('is-clamped');

      requestAnimationFrame(() => {
        const isOverflowing = this.#desc.scrollHeight > this.#desc.clientHeight + 1;
        this.#btn.hidden = !isOverflowing;

        if (!isOverflowing) {
          this.#desc.classList.remove('is-clamped');
        }
      });
    }
  }

  if (!customElements.get('editorial-product-description')) {
    customElements.define('editorial-product-description', EditorialProductDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-split-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-product-buy-now')) {
    class EditorialProductBuyNow extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.#onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
      }

      #onClick = async (event) => {
        event.preventDefault();
        if (this.disabled) return;

        const formComponent = this.closest('product-form-component');
        const form = formComponent?.querySelector('form');
        if (!form || !window.fetch) return;

        const formData = new FormData(form);
        if (!formData.get('id')) return;

        this.disabled = true;

        try {
          const response = await fetch(Theme.routes.cart_add_url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          const data = await response.json();
          if (!response.ok) {
            throw new Error(data?.description || data?.message || 'Cart error');
          }

          window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
        } catch (error) {
          console.error(error);
          this.disabled = false;
        }
      };
    }

    customElements.define('editorial-product-buy-now', EditorialProductBuyNow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-video-gallery"] && !Shopify.designMode) return;
  try {
    
  const bindEditorialVideoGalleryDeferred = (root = document) => {
    root.querySelectorAll('.editorial-video-gallery .editorial-video-card__deferred').forEach((deferred) => {
      const poster = deferred.querySelector('.deferred-media__poster-button');
      if (!poster || poster.dataset.evvgBound === 'true') return;
      poster.dataset.evvgBound = 'true';
      poster.addEventListener('click', () => {
        if (typeof deferred.showDeferredMedia === 'function' && !deferred.getAttribute('data-media-loaded')) {
          deferred.showDeferredMedia();
        }
      });
    });
  };

  bindEditorialVideoGalleryDeferred();
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) bindEditorialVideoGalleryDeferred(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-video-grid"] && !Shopify.designMode) return;
  try {
    
  const bindEditorialVideoDeferred = (root = document) => {
    root.querySelectorAll('.editorial-video-card__deferred').forEach((deferred) => {
      const poster = deferred.querySelector('.deferred-media__poster-button');
      if (!poster || poster.dataset.evgBound === 'true') return;
      poster.dataset.evgBound = 'true';
      poster.addEventListener('click', () => {
        if (typeof deferred.showDeferredMedia === 'function' && !deferred.getAttribute('data-media-loaded')) {
          deferred.showDeferredMedia();
        }
      });
    });
  };

  bindEditorialVideoDeferred();
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) bindEditorialVideoDeferred(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
